module.exports = __webpack_public_path__ + "img/twitter_logo.2d8eb5e3.svg";